<ng-template #emptyTemplate>
  <span class="ds-body-2 color-light" data-testid="scanned-quantities-empty">
    {{ '#KOMMISSIONIERUNG.DIALOGS.ERFASSTE_MENGEN.EMPTY' | translate }}
  </span>
</ng-template>

<soft-resource-container [resource]="scans" [emptyTemplate]="emptyTemplate">
  @if (rows().length > 0) {
    <ul role="list" class="flex flex-col gap-1.5">
      @for (scan of rows(); track scan.id) {
        @let artikel = scan.artikelMenge.artikel;
        <li
          class="soft-card soft-panel-shadow rounded-md flex items-center justify-between gap-2"
          [attr.data-testid]="'scanned-quantity-row-' + scan.id"
        >
          <div class="flex flex-col min-w-0">
            <span class="flex items-center gap-2 flex-wrap">
              <span class="ds-caption color-light">{{ artikel.nummer }}</span>
              @if (scan.kzerfassung === 'R') {
                <span
                  class="flex flex-row gap-1 items-center bg-warning rounded-full px-2 text-warning-contrast ds-caption w-fit"
                  data-testid="scanned-quantity-retoure"
                >
                  <soft-icon name="fa-regular fa-turn-left" class="fa-xs"></soft-icon>
                  {{ '#KOMMISSIONIERUNG.DIALOGS.ERFASSTE_MENGEN.RETOURE' | translate }}
                </span>
              } @else if (scan.kzerfassung === 'Z') {
                <span
                  class="flex flex-row gap-1 items-center bg-success rounded-full px-2 text-success-contrast ds-caption w-fit"
                  data-testid="scanned-quantity-zusatz"
                >
                  <soft-icon name="fa-regular fa-square-plus" class="fa-xs"></soft-icon>
                  {{ '#KOMMISSIONIERUNG.DIALOGS.ERFASSTE_MENGEN.ZUSATZPOSITION' | translate }}
                </span>
              }
            </span>
            <span class="ds-body-1-semibold">{{ artikel.artbez1 }}</span>
            @if (scan.artikelMenge.vermerk; as vermerk) {
              <span class="ds-caption color-light" data-testid="scanned-quantity-vermerk">
                {{ '#KOMMISSIONIERUNG.DIALOGS.ERFASSTE_MENGEN.VERMERK' | translate }}: {{ vermerk }}
              </span>
            }
            @if (scan.lagerplatz?.lagerplatz; as lagerplatz) {
              <span class="ds-caption color-light">{{ lagerplatz }}</span>
            }
            <soft-batch-info [charge]="scan.artikelMenge.charge" [mhd]="scan.artikelMenge.mhd" />
            @if (scan.scanPalette?.sscc; as sscc) {
              <span class="ds-caption color-light" data-testid="scanned-quantity-palette">
                {{ '#KOMMISSIONIERUNG.DIALOGS.SCAN_KORREKTUR.PALETTE' | translate }}: {{ sscc }}
              </span>
            }
          </div>
          <div class="flex items-center gap-2 shrink-0">
            <span
              class="ds-body-1-semibold whitespace-nowrap mr-1"
              data-testid="scanned-quantity-amount"
            >
              {{ scan.artikelMenge.menge }} {{ scan.artikelMenge.einheit.arteh }}
            </span>
            @if (!scan.scanPalette) {
              <soft-ds-button
                variant="outline"
                mode="iconOnly"
                size="md"
                [aria-label]="'#KOMMISSIONIERUNG.DIALOGS.ERFASSTE_MENGEN.BEARBEITEN' | translate"
                (click)="edit(scan)"
                [attr.data-testid]="'scanned-quantity-edit-' + scan.id"
              >
                <ng-template softSlot="leading">
                  <soft-ds-icon name="fa-regular fa-pen" />
                </ng-template>
              </soft-ds-button>
            }
            <soft-ds-button
              variant="destructive"
              mode="iconOnly"
              size="md"
              [aria-label]="'#KOMMISSIONIERUNG.DIALOGS.ERFASSTE_MENGEN.ENTFERNEN' | translate"
              (click)="remove(scan)"
              [attr.data-testid]="'scanned-quantity-remove-' + scan.id"
            >
              <ng-template softSlot="leading">
                <soft-ds-icon name="fa-regular fa-trash" />
              </ng-template>
            </soft-ds-button>
          </div>
        </li>
      }
    </ul>
  }
</soft-resource-container>
